var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85076 2.92795L5.01934 0.0965258C4.89064 -0.0321753 4.69759 -0.0321753 4.56889 0.0965258L3.53928 1.12613C3.3784 1.28701 3.44275 1.48006 3.53928 1.57659L3.76451 1.80181L2.79925 2.76707C2.31662 2.67055 0.997433 2.44532 0.289577 3.15318C0.160876 3.28188 0.160876 3.47493 0.289577 3.60363L2.12357 5.43762L0.0965258 7.46466C-0.0321753 7.59336 -0.0321753 7.78641 0.0965258 7.91511C0.225227 8.04381 0.450454 8.01164 0.546979 7.91511L2.57402 5.88807L4.40801 7.72206C4.60106 7.88294 4.79411 7.81859 4.85846 7.72206C5.56632 7.01421 5.34109 5.69502 5.24457 5.21239L6.20982 4.24713L6.43505 4.47236C6.56375 4.60106 6.7568 4.60106 6.88551 4.47236L7.91511 3.44275C7.97946 3.2497 7.97946 3.05665 7.85076 2.92795Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.5bfe606dc51f11538449c664da80be8d.svg";
export { ForwardRef as ReactComponent };